import { Record } from 'immutable';

export const mkBuild = Record({
  bugsnag_api_key: 'unknown',
  bugsnag_release_stage: 'unknown',
  cobrowse_license: 'unknown',
  community_url: 'unknown',
  finicity_env: 'unknown',
  hotjar_key: null,
  inactivity_countdown_timeout_in_seconds: 30,
  inactivity_timeout_in_seconds: 900,
  intercom_app_id: 'unknown',
  ld_client_id: 'unknown',
  mixpanel_token: 'unknown',
  plaid_env: 'unknown',
  sso_client_id: 'unknown',
  stripe_mode: 'unknown',
});

export const mkClient = Record({
  product: 'unknown',
  product_name: 'unknown',
  app_version: 'unknown',
  build: 'unknown',
  commit: 'unknown',
  build_type: 'unknown',
  environment: 'unknown',
  protocol: 'unknown',
  hostname: 'unknown',
  port: 'unknown',
});

export const mkCommon = Record({
  handle_retry: undefined,
  mixpanelProxy: '',
  mui_x_pro_license: '',
  pendo_api_key: 'unknown',
  plaid_client_name: 'unknown',
  plaid_product: 'unknown',
  plaid_public_key: 'unknown',
  stripe_client_id_live: 'unknown',
  stripe_client_id_test: 'unknown',
  stripe_public_key_live: 'unknown',
  stripe_public_key_test: 'unknown',
  external: {},
});

export const mkEnvironment = Record({
  client_id: 'unknown',
  client_secret: 'unknown',
  firebase_api_key: 'unknown',
  firebase_app_id: 'unknown',
  firebase_messaging_sender_id: 'unknown',
  firebase_project_id: 'unknown',
  myaccount_url: 'unknown',
  pick_your_plan_url: 'unknown',
  plaid_webhook: 'unknown',
  services_url: 'unknown',
  signature_public_key: 'unknown',
  signin_url: 'unknown',
  websocket_qcs_url: 'unknown',
});

export const mkHost = Record({
  storybook: undefined,
  environment_default: undefined,
  homepage_url: undefined,
  redirect_uri: undefined,
});

export const mkConfig = Record({
  builds: null,
  client: null,
  common: null,
  environments: null,
  hosts: null,
});
